import Button from '@app/components/button';
import CircularSpinner from '@app/components/icons/circular-spinner';
import { T } from '@app/components/translation';

import style from './guest-conversion.module.scss';

type GuestConversionModalActionsProps = {
  isSubmitting: boolean;
  isValidating: boolean;
  isInValid: boolean;
  handleSubmit: () => void;
  handleClose: () => void;
};

const GuestConversionModalActions: React.FC<GuestConversionModalActionsProps> = ({
  isSubmitting,
  isValidating,
  isInValid,
  handleSubmit,
  handleClose,
}) => {
  const disabled = Boolean(isSubmitting || isValidating || isInValid);

  return (
    <div className={style.Buttons}>
      <Button
        kind="linkSeparate"
        onClick={handleClose}
      >
        <T
          _str="Cancel"
          _comment="Button text in the Guest Conversion signup flow"
        />
      </Button>
      <Button
        kind="primary"
        onClick={handleSubmit}
        icon={isSubmitting ? CircularSpinner : undefined}
        disabled={disabled}
      >
        <T
          _str="Create"
          _comment="Button text in the Guest Conversion signup flow"
        />
      </Button>
    </div>
  );
};

export default GuestConversionModalActions;
